function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import App, { CookiesInfo, IntlHelmet, LanguageProvider, LanguageSelector, OfflineOverlay } from 'modules/App';
import { SupportedPlatforms } from 'modules/Account';
import messages from '../../messages';
import SupportLink from '../../partials/SupportLink';
import styles from './SignInLayout.pcss';
var _React_Component;
class SignInLayout extends (_React_Component = React.Component) {
    onKeyDown(evt) {
        // If ESC
        if (evt.keyCode === 27) {
            this.props.onCloseDropdown();
        }
    }
    renderSideContent() {
        const { app } = this.props;
        const welcomeImg = app && app.customWelcome ? `welcome/${app.key}.png` : 'welcome.png';
        return /*#__PURE__*/ _jsx("aside", {
            className: cn('col-6', styles.container, styles['container--side']),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.containerInner,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "text--center",
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: `/aid/assets/img/${welcomeImg}`,
                            className: styles.welcomeImage,
                            alt: app && app.name
                        }),
                        /*#__PURE__*/ _jsx(SupportedPlatforms, {})
                    ]
                })
            })
        });
    }
    renderPageHeader() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.logoBar,
            children: /*#__PURE__*/ _jsx("img", {
                src: "/aid/assets/img/app-logo.png",
                className: styles.logoBar__logo,
                alt: "Contour Diabetes Care"
            })
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('col', styles.container),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.containerInner,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: this.props.children
                    })
                }),
                /*#__PURE__*/ _jsx(LanguageSelector, {}),
                /*#__PURE__*/ _jsx(SupportLink, {})
            ]
        });
    }
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                onClick: this.props.onCloseDropdown,
                onKeyDown: (evt)=>this.onKeyDown(evt),
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx(CookiesInfo, {}),
                    this.renderPageHeader(),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex h-100",
                        children: [
                            this.renderContent(),
                            this.renderSideContent()
                        ]
                    }),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
}
_define_property(SignInLayout, "propTypes", {
    // Explicit props
    app: PropTypes.object,
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object,
    // Implicit props
    children: PropTypes.node,
    // Implicit actions
    onCloseDropdown: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedSignInLayout = connect(null, mapDispatchToProps)(SignInLayout);
export default withStyles(styles)(ConnectedSignInLayout);
